import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/auth';
import 'firebase/compat/messaging';
import 'firebase/compat/functions';

const config = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_DATABASE_URL,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID,
};
let messaging: firebase.messaging.Messaging | null = null;
if (!firebase.apps.length) {
  firebase.initializeApp(config);
}
export const VAPID_KEY = import.meta.env.VITE_VAPID_KEY || undefined;
if (firebase.messaging.isSupported()) {
  // `usePublicVapidKey` is gone in the current messaging-compat API — the vapid key is now
  // passed per call, as `getToken({ vapidKey: VAPID_KEY })`.
  messaging = firebase.messaging();
}
const db = firebase.firestore();
// Some mobile networks break Firestore's streaming WebChannel (Listen/channel 400s → "client is offline"); fall back to long-polling when that happens.
db.settings({ experimentalAutoDetectLongPolling: true, merge: true });
const storage = firebase.storage();
const auth = firebase.auth();
const functions = firebase.app().functions('europe-west1');

if (import.meta.env.VITE_EMULATOR === 'TRUE') {
  db.useEmulator('localhost', 8080);
  auth.useEmulator('http://localhost:9099/');
  functions.useEmulator('localhost', 5001);
  storage.useEmulator('localhost', 9199);
}

export { db, storage, auth, functions, messaging };
export default firebase;
